import React, { useEffect, useState } from 'react'
import HeaderTitle from '../../components/HeaderTitle'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import swal from 'sweetalert'
import { Helmet } from 'react-helmet'

function Employees() {
    const { token } = useSelector((state) => state.auth)
    const [employees, setEmployees] = useState([])

    const getEmployees = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/employees`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                setEmployees(response.data)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    const deleteEmployee = (id) => {
        console.log("delete employee", id)
        swal({
            title: "Çalışanı silmek istediğinize emin misiniz?",
            text: "Bu işlem geri alınamaz!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    axios.delete(`${process.env.REACT_APP_SERVICE_URL}/employees/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then((response) => {
                            console.log(response.data)
                            getEmployees()
                            swal("Çalışan başarıyla silindi", {
                                icon: "success",
                            });
                        })
                        .catch((error) => {
                            console.error(error)
                            swal("Çalışan silinirken hata oluştu", {
                                icon: "error",
                            });
                        })
                }
            });

    }

    useEffect(() => {
        getEmployees()
    }, [])

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Çalışanlar</title>
                <meta name='description' content='Çalışanlar' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            </Helmet>
            <HeaderTitle title="Çalışanlar" description="Çalışanların listesi" />
            <div className="row">
                <div className='col-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='d-flex flex-wrap align-items-center gap-2 mb-2 mb-md-0'>
                                <button type='button' title="Yenile" aria-label="Listeyi yenile" onClick={getEmployees} className='btn btn-outline-secondary btn-app btn-app--icon'>
                                    <i className='bi bi-arrow-clockwise'></i>
                                </button>
                                <Link to='/employees/create' className='btn btn-dark btn-app'>
                                    <i className='bi bi-plus-lg'></i>
                                    Yeni çalışan
                                </Link>
                            </div>
                            <div className='table-responsive mt-3'>
                                <table className='table table-striped'>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Adı</th>
                                            <th>Soyadı</th>
                                            <th>Telefon</th>
                                            <th>İşlem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            employees?.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className='align-middle'>{item.id}</td>
                                                        <td className='align-middle'>{item.firstName}</td>
                                                        <td className='align-middle'>{item.lastName}</td>
                                                        <td className='align-middle'>{item.phoneNumber}</td>
                                                        <td className='align-middle'>
                                                            <div className='d-inline-flex flex-wrap align-items-center gap-1'>
                                                                <Link to={`/employees/edit/${item.id}`} className='btn btn-outline-primary btn-app'>Düzenle</Link>
                                                                <button type="button" className='btn btn-outline-danger btn-app'
                                                                    onClick={() => deleteEmployee(item.id)}
                                                                >Sil</button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Employees